import request from "../shared/http";

const unwrap = (res) => res?.data ?? res;

class VerticalActionRegistryService {
  actionRegistry() {
    return request.get("/vertical/actions-registry").then(unwrap);
  }
}

export default new VerticalActionRegistryService();
